import { InjectionKey, ref } from 'vue';
import { Maintenance } from '@/modules/Maintenance';

export const useMaintenance = () => {
  const wpMaintenance = ref<Maintenance>();

  const setWpMaintenance = (maintenance: Maintenance) => {
    wpMaintenance.value = maintenance;
  };

  return {
    setWpMaintenance,
  };
};

type TypeMaintenance = ReturnType<typeof useMaintenance>;
export const MaintenanceKey: InjectionKey<TypeMaintenance> = Symbol('Maintenance');
